import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {BoulderListPage} from './boulder-list.page';
import {ComponentsModule} from '../../components/components.module';
import {PipesModule} from '../../pipes/pipes.module';
import {TranslateModule} from '@ngx-translate/core';
import {AutoFocusDirective} from './autofocus.directive';
import {BoulderDetailsPageModule} from '../boulder-details/boulder-details.module';
import { BoulderListEntryComponent } from 'src/components/boulder-list-entry/boulder-list-entry.component';
import { MainMenuComponent } from '../../components/main-menu/main-menu.component';
import { StoreModule } from '@ngrx/store';
import { activeGymFeatureKey, activeGymReducer } from 'src/store/active-gym/active-gym.reducer';

const routes: Routes = [
  {
    path: '',
    component: BoulderListPage
  },
  {
    path: '/:reload',
    component: BoulderListPage
  },
  {
    path: '/:gymId/:boulderId',
    component: BoulderListPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    BoulderDetailsPageModule,
    BoulderListEntryComponent,
    RouterModule.forChild(routes),
    PipesModule,
    TranslateModule,
    MainMenuComponent
  ],
  declarations: [BoulderListPage, AutoFocusDirective]
})
export class BoulderListPageModule {
}
